import axios from "axios";
import {
  FETCH_PET_QUEUE_RECORDS,
  RETRY_FETCH_CONTRACT,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);

export function fetchPetQueueRecords() {
  return {
    type: FETCH_PET_QUEUE_RECORDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/woostore/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function retryFetchContract(id) {
  return {
    type: RETRY_FETCH_CONTRACT,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/woostore/retry/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}